import Delllatitude5420 from "../assets/dell/DellLatitude5420.jpg";
import DellPrecision5560 from "../assets/dell/DellPrecision5560.jpg";
import DellAlienwareX14 from "../assets/dell/DellAlienwareX14.jpg";
import DellLatitude5430 from "../assets/dell/DellLatitude5430.jpeg";
import DellLatitude5450 from "../assets/dell/DellLatitude5450.jpeg";

const dellProducts = [
  {
    id: 1,
    name: "Dell Latitude 5420",
    image: Delllatitude5420,
    specs: [
      "Intel i7-11th Gen processor",
      "16GB RAM",
      "512GB SSD Nvme",
      "14 FH Display",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in Dell Latitude 5420",
  },
  {
    id: 2,
    name: "Dell Precision 5560",
    image: DellPrecision5560,
    specs: [
      "Intel i9-11950H processor",
      "32 GB RAM",
      "1 TB SSD Nvme",
      "15.6 4K Resolution TOUCH display",
      "Nvidia RTX A2000 4GB GPU",
    ],
    price: "₹58,999",
    whatsappText: "Hi, I am interested in Dell Precision 5560",
  },
  {
    id: 3,
    name: "Dell Alienware X14",
    image: DellAlienwareX14,
    specs: [
      "Intel i7-12700H processor",
      "16GB DDR5 4800Mhz RAM",
      "512GB SSD Nvme 4.0",
      "14 144Hz FH Display",
      "Nvidia Geforce RTX3050 Ti | Windows 11",
    ],
    price: "₹1,45,999",
    whatsappText: "Hi, I am interested in Dell Alienware X14",
  },
  {
    id: 4,
    name: "Dell Latitude 5430",
    image: DellLatitude5430,
    specs: [
      "Intel i7-12th Gen Processor",
      "16 GB RAM",
      "512 GB SSD Nvme",
      "14 FH Display",
      "Intel Iris 8GB GPU",
      "Window 11 pro"
    ],
    price: "₹89,999",
    whatsappText: "Hi, I am interested in Dell Latitude 5430",
  },
  {
    id: 5,
    name: "Dell Latitude 5450",
    image: DellLatitude5450,
    specs: [
      "Intel Core Ultra 5",
      "135H processor(14 cores)",
      "Intel NPU AI Boost 18GB",
      "Intel GPU 18GB",
      "32GB DDR5 5600 RAM",
      "512GB SSD Nvme",
      "14 FHD Display",
      "Window 11 pro"
    ],
    price: "₹89,999",
    whatsappText: "Hi, I am interested in Dell Latitude 5450",
  }
];

export default dellProducts;
